import "./google.css2.js";
const s = "https://static.parastorage.com/services/fonts-data/dist/google.tmlv7ubcy6tb9q7fz88p.css";
export {
  s as default
};
//# sourceMappingURL=google.css.js.map
